import { useEffect, useState } from "react";

export function useDebouncedState<T>(value: T, delay: number): T {
    const [state, setState] = useState<T>(value);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setState(value);
        }, delay);
        return () => clearTimeout(timeoutId);
    }, [value, delay]);

    return state;
}
